interface IFullscreenableHTMLElement extends HTMLElement {
  readonly requestFullScreen: () => void;
}

// @ts-ignore
interface IFullscreenAbleDocument extends Document {
  readonly fullscreenElement: () => void;
  readonly documentElement: IFullscreenableHTMLElement | null;
}

const doc = document as unknown as IFullscreenAbleDocument;

export const toggleFullScreen = () => {
  if (!doc.fullscreenElement && doc.documentElement) {
    doc.documentElement.requestFullscreen();
  } else {
    if (doc.exitFullscreen) {
      doc.exitFullscreen();
    }
  }
};

export const initFullScreenKeyHandler  = () => {
  doc.addEventListener("keydown", (e) => {
    if (e.altKey && e.key === "Enter") {
      toggleFullScreen();
    }
  }, false);
};



// WEBPACK FOOTER //
// ./src/fullScreenHandler.tsx